/**
 * Audit service — reads consumer-v1 quote-fabrication audit results and saves notes.
 */
import { apiClient } from './api';

const auditService = {
  async getResults() {
    const res = await apiClient.get('/audit/results');
    return res.data;
  },

  async updateNotes(articleId, payload) {
    const res = await apiClient.patch(`/audit/notes/${articleId}`, payload);
    return res.data;
  },
};

export default auditService;
